import { hasValue } from "../../../utils/functions.js";

export default {
  name: "ParceiroAtendimentoIdParceiro",
  data: function () {
    return {
      idPartner: null,
      countFilter: 0,
      filter: {
        IdPartner: null,
        IdUserInternal: null,
        CodigoParceiroAtendimentoCategoria: null,
      },
      validatedFormValidation: false,
      loadingList: false,
      loadingAddUpdate: false,
      loadingModal: false,
      idPartner: 0,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      atendimentos: [],
      usersInternal: [],
      parceiroAtendimentoCategoriaFiltro: [],
      parceiroAtendimentoCategoriaForm: [],
      infoAtendimento: {
        Partner: {
          Id: this.idPartner,
        },
        UserInternal: {
          Id: this.$getUserInternal().Id,
        },
        Categoria: {
          Codigo: null,
        },
        Descricao: null,
      },
      isSeeing: false,
      isCreating: false,
      modalTitle: "Novo Atendimento ao Parceiro",
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  watch: {
    "pagination.PageNumber": function () {
      this.ListarParceiroAtendimento();
    },
    "pagination.RowsPerPage": function () {
      this.ListarParceiroAtendimento();
    },
  },
  mounted() {
    if (this.$route.params.idPartner !== null && this.$route.params.idPartner !== undefined) {
      this.idPartner = this.$route.params.idPartner;
    }
    this.ListarParceiroAtendimentoCategoriaDropDown();
    this.ListarParceiroAtendimento();
    this.ListUserInternal();
  },
  methods: {
    ResetInfoAtendimento: function () {
      this.infoAtendimento = {
        Partner: {
          Id: this.idPartner,
        },
        UserInternal: {
          Id: this.$getUserInternal().Id,
        },
        Categoria: {
          Codigo: null,
        },
        Descricao: null,
      };
    },
    SalvarAtendimento() {
      this.validatedFormValidation = true;
      this.$refs.AtendimentoValidacaoForm.validate().then((isValid) => {
        if (isValid) {
          if (this.isCreating) {
            // Add
            this.loadingAddUpdate = true;
            this.loadingModal = true;
            this.$store
              .dispatch("AdicionarParceiroAtendimento", this.infoAtendimento)
              .then(() => {
                this.$makeToast("Sucesso ao adicionar o atendimento", "success", "Atendimento ao Parceiro");
                this.ListarParceiroAtendimento();
                this.$bvModal.hide("mFormAtendimento");
              })
              .catch((error) => {
                this.$makeToast("Não foi possível adicionar o atendimento", "danger", "Atendimento ao Parceiro", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.loadingModal = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("AlterarParceiroAtendimento", this.infoAtendimento)
              .then(() => {
                this.$makeToast("Suas modificações foram salvas na base de dados", "success", "Atendimento ao Parceiro");
                this.ListarParceiroAtendimento();
                this.$bvModal.hide("mFormAtendimento");
              })
              .catch((error) => {
                this.$makeToast(undefined, "danger", "Erro ao atualizar o atendimento", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },

    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListarParceiroAtendimento();
    },

    BuscarParametrosListarParcerioAtendimento(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Partner.Id": hasValue(this.filter.IdPartner) ? this.filter.IdPartner : 0,
        "Object.UserInternal.Id": this.filter.IdUserInternal,
        "Object.Categoria.Codigo": this.filter.CodigoParceiroAtendimentoCategoria,
      };

      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    ListarParceiroAtendimento: function () {
      this.countFilter = 0;
      if (this.idPartner !== null) this.filter.IdPartner = this.idPartner;
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++;
      if (hasValue(this.filter.CodigoParceiroAtendimentoCategoria)) this.countFilter++;

      this.loadingList = true;
      let data = this.BuscarParametrosListarParcerioAtendimento();
      delete data.TotalItems;
      this.$store
        .dispatch("ListarParceiroAtendimento", { params: data })
        .then(
          (response) => {
            this.atendimentos = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          (error) => {
            this.$makeToast("Não foi possível listar os atendimentos", "danger", "Atendimento ao Parceiro", error);
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },

    ListUserInternal: function () {
      this.$store
        .dispatch("ListUserInternal", { params: {} })
        .then((response) => {
          this.usersInternal = response.Objects;
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página", "danger", "Erro ao obter lista de usuários", error);
        });
    },

    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },

    ResetFilter: function () {
      this.filter = {
        IdPartner: this.idPartner,
        IdUserInternal: null,
        CodigoParceiroAtendimentoCategoria: null,
      };
      this.ListarParceiroAtendimento();
    },

    AbrirAtendimento: function (e, i, view) {
      e.preventDefault();
      this.validatedFormValidation = false;
      this.loadingAddUpdate = false;
      this.ResetInfoAtendimento();

      if (view == undefined && i != undefined) {
        // Edit
        this.isCreating = false;
        this.idAtendimento = this.atendimentos[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Atendimento ao Parceiro";
        this.BuscarAtendimento(this.idAtendimento);
      } else if (view == undefined && i == undefined) {
        // Add new
        this.isCreating = true;
        this.isSeeing = false;
        this.modalTitle = "Novo Atendimento ao Parceiro";
      } else {
        // View
        this.isCreating = false;
        this.idAtendimento = this.atendimentos[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Atendimento ao Parceiro";
        this.BuscarAtendimento(this.idAtendimento);
      }
      this.$bvModal.show("mFormAtendimento");
    },

    BuscarAtendimento: function (id) {
      this.loadingModal = true;
      this.$store
        .dispatch("BuscarParceiroAtendimento", { id: id })
        .then((response) => {
          this.infoAtendimento = response;
          this.$bvModal.show("mFormAtendimento");
        })
        .catch((error) => {
          this.$makeToast(
            "Não foi possível buscar as informações do atendimento",
            "danger",
            "Atendimento ao Parceiro",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },

    ListarParceiroAtendimentoCategoriaDropDown() {
      this.$store
        .dispatch("ListarParceiroAtendimentoCategoriaDropDown", { ListaAtivaEExcluida: true })
        .then((response) => {
          const PAC = response.Objects;
          if (PAC.length > 0) {
            this.parceiroAtendimentoCategoriaFiltro = PAC;
            this.parceiroAtendimentoCategoriaForm = PAC.filter((categoria) => !categoria.EhExcluido);
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        });
    },

    GerarRelatorio() {
      this.loadingList = true;
      const params = this.BuscarParametrosListarParcerioAtendimento(true);
      this.$store
        .dispatch("RelatorioParceiroAtendimento", { params })
        .then((response) => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingList = false;
          }, 1200);
        });
    },
  },
};


// WEBPACK FOOTER //
// ./src/components/pages/ParceiroAtendimentoIdParceiro/ParceiroAtendimentoIdParceiro.js